'use client';

import type { ReactNode } from 'react';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { Badge } from '../../components/badge';
import { BodyStrong, MetaDefault } from '../../components/typography';
import { Tooltip } from '../../components/tooltip';

type PrimaryDomainCellProps = {
  domain: string;
  primaryLabel: string;
  redirectTargetLabel?: string;
  suffix?: ReactNode;
};

export const PrimaryDomainCell = ({
  domain,
  primaryLabel,
  redirectTargetLabel,
  suffix,
}: PrimaryDomainCellProps) => (
  <VStack alignItems="stretch" gap={0.5} minW={0} w="full">
    <HStack gap={1} alignItems="center" minW={0} w="full">
      <Tooltip title={domain}>
        <Box flex="1" minW={0} truncate>
          <BodyStrong truncate>{domain}</BodyStrong>
        </Box>
      </Tooltip>
      <Badge variant="fill" colorScheme="terra.9" size="sm">
        {primaryLabel}
      </Badge>
      {suffix}
    </HStack>
    {redirectTargetLabel ? (
      <Tooltip title={redirectTargetLabel}>
        <Box minW={0} truncate pl={2}>
          <MetaDefault color="fg.muted" truncate>
            {redirectTargetLabel}
          </MetaDefault>
        </Box>
      </Tooltip>
    ) : null}
  </VStack>
);
